import { render, staticRenderFns } from "./addCliente.vue?vue&type=template&id=6bc2a2c8&scoped=true&"
import script from "./addCliente.vue?vue&type=script&lang=js&"
export * from "./addCliente.vue?vue&type=script&lang=js&"
import style0 from "./addCliente.vue?vue&type=style&index=0&id=6bc2a2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2a2c8",
  null
  
)

export default component.exports